import { graphql } from '../../gql';

export const GET_MANAGER = graphql(`
  query getManager {
    manager {
      ... on Manager {
        id
        idStandort
        email
        vorname
        nachname
        managerrechte {
          tagebuch
          einstellungen
          admin
          termine
          neuigkeiten
          statusmails
          konflikte
          id
          kalender
          auswertung {
            dienstplan
            arbeitszeit
            personal
          }
          dienstplan {
            freigabe
            erlaubt
            bearbeiten
            mitarbeiterEinteilen
            schichtvorlagen
          }
          abrechnung {
            monatsabschluss
            export
          }
          mitarbeiter {
            standortwechsel
            personalfragebogen
            urlaubskonto
            jahreskonto
            fristen
            verfuegbarkeit
            erlaubt
            eingeschraenkt
            dokumente
          }
          arbeitszeit {
            geldbetraegeAnzeigen
            nurHeute
            erlaubt
            alleTage
            bearbeiten
          }
        }
        settings {
          arbeitszeitenDesign
        }
      }
      ... on ManagerError {
        type
        message
      }
    }
  }
`);

export const GET_MONAT_IS_ABGESCHLOSSEN = graphql(`
  query getMonatIsAbgeschlossen($journaltag: DateTime!) {
    manager {
      ... on Manager {
        idStandort
        standorte {
          id
          isMonatAbgeschlossen(journaltag: $journaltag)
        }
      }
    }
  }
`);

export const GET_FEIERTAG_BY_STANDORT_ID_AND_DATUM = graphql(`
  query getFeiertagByStandortIdAndDatum(
    $journaltag: DateTime!
    $standortId: String!
  ) {
    feiertagByStandortIdAndDatum(datum: $journaltag, standortId: $standortId) {
      name
    }
  }
`);
